export default __webpack_public_path__ + "static/media/gab1.1b499c24.png";